import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { OpenNewTab } from '../../../../content/directives/open-new-tab.directive';

import { DISCOGRAPHY } from '../discography-data';

@Component({
  selector: 'app-discography-content',
  imports: [NgOptimizedImage, OpenNewTab],
  templateUrl: './discography-content.component.html',
  styleUrl: './discography-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscographyContentComponent {
  readonly albums = DISCOGRAPHY;
}
